import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { complianceEffects } from 'src/app/compliance/store/effects/compliance-effects';
import { complianceReducers } from 'src/app/compliance/store/reducers';
import { complianceFeatureKey } from 'src/app/compliance/store/selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(complianceFeatureKey, complianceReducers),
        EffectsModule.forFeature(complianceEffects)
    ]
})
export class ComplianceStoreModule {}
